import { VenueType } from '@thurstech/commons/dist/entity/venue';
import React, { useEffect } from 'react';
import { FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';

import Input from '../../../components/input/Input';
import { VenueCardFormData } from '../../../validation/operations/products/venueCard';

interface PackageCardProps {
  index: number;
  title: string;
  venueType: VenueType;
  isResourcesLinkedToVenue?: boolean;
  useForm: {
    setValue: UseFormSetValue<VenueCardFormData>;
    watch: UseFormWatch<VenueCardFormData>;
    register: UseFormRegister<VenueCardFormData>;
    errors: FieldErrors<VenueCardFormData>;
  };
}

export const PackageCard: React.FC<PackageCardProps> = ({
  title,
  venueType,
  isResourcesLinkedToVenue,
  index,
  useForm
}) => {
  const totalTickets = useForm.watch(`packages.${index}.resources.count`);
  useEffect(() => {
    if (!isResourcesLinkedToVenue && totalTickets) {
      useForm.setValue(
        `packages.${index}.availableTickets`,
        totalTickets - (useForm.watch(`packages.${index}.bookedTickets`) ?? 0)
      );
    }
  }, [totalTickets]);

  return (
    <div className="bg-white p-4 rounded w-full">
      <div className="mb-2">
        <span className="font-bold text-xl">{title}</span>
      </div>
      <Input {...useForm} readOnly hidden name={`packages.${index}.id`} type="text" />
      <Input
        {...useForm}
        label="Price"
        name={`packages.${index}.price`}
        type="number"
        prefix="₹"
        className="text-right"
      />

      {!isResourcesLinkedToVenue && (
        <>
          <Input
            {...useForm}
            label={venueType === VenueType.TIME_BOOKING ? 'Total Courts' : 'Total Tickets'}
            name={`packages.${index}.resources.count`}
            type="number"
            readOnly={venueType === VenueType.TIME_BOOKING}
            className="text-right"
          />
          <Input
            {...useForm}
            label="Available Tickets"
            name={`packages.${index}.availableTickets`}
            type="number"
            hidden={venueType === VenueType.TIME_BOOKING}
            readOnly
            className="text-right"
          />
        </>
      )}
      <Input
        {...useForm}
        label="Discount"
        name={`packages.${index}.discount`}
        type="number"
        suffix="%"
        className="text-right"
      />
    </div>
  );
};
